export type PasswordPolicyRule =
  'length' | 'digits' | 'upperCase' | 'lowerCase' | 'specialChars';

export const PASSWORD_POLICY_RULES: readonly PasswordPolicyRule[] = [
  'length',
  'digits',
  'upperCase',
  'lowerCase',
  'specialChars',
] as const;

export type PasswordPolicyChecklistItem = {
  rule: PasswordPolicyRule;
  met: boolean;
};

export function getPasswordPolicyViolations(
  password: string,
): PasswordPolicyRule[] {
  const violations: PasswordPolicyRule[] = [];

  // length(8)
  if (password.length < 8) {
    violations.push('length');
  }

  // digits(1)
  if (!/\d/.test(password)) {
    violations.push('digits');
  }

  // upperCase(1)
  if (!/[A-Z]/.test(password)) {
    violations.push('upperCase');
  }

  // lowerCase(1)
  if (!/[a-z]/.test(password)) {
    violations.push('lowerCase');
  }

  // specialChars(1)
  if (!/[^A-Za-z0-9]/.test(password)) {
    violations.push('specialChars');
  }

  return violations;
}

export function getPasswordPolicyChecklist(
  password: string,
): PasswordPolicyChecklistItem[] {
  const violations = new Set(getPasswordPolicyViolations(password));
  return PASSWORD_POLICY_RULES.map((rule) => ({
    rule,
    met: !violations.has(rule),
  }));
}

export function isPasswordPolicyCompliant(password: string): boolean {
  return getPasswordPolicyViolations(password).length === 0;
}
